<template>
    <form @submit="onSubmit" method="POST" ref="form" id="sendy-form">
            
            <input type="hidden" name="list" value="y3Ep0BGWhxkmrB1763I53pMQ"/>
            <input type="hidden" name="api_key" value="Z0skjz8tyn5VcME6DCmr"/>
            <div id="hp">
                <label for="hp">HP</label>
                <input type="text" name="hp" id="hp">
			</div>
        <div class="sendyInlineWrapper">
                <div class="sendySubmitInline">
                    <input type="email" v-model="email" name="email" placeholder="Enter email address" id="email"/>
                    <!-- <button class="btn btn-success">Submit</button> -->
                    <input type="image" class="animated pulse animated-infinite bounce_button" src="/static/assets/images/Subscribe.png" alt="dwerve-subscribe" name="submit" id="submit"/>
                </div>
                <!-- <p class="subtitle">You will be entered for a chance to win <span class="sign__word animated tada infinite"> alpha access!</span></p> -->
                 <p class="subtitle">Subscribe to get development updates!</p>
        </div>
          
        </form>
</template>

<script>
import { mapActions } from 'vuex';
export default {
        data() {
            return {
              email: '',
              description: '',
              output: ''
            };
        },
 methods: {
    ...mapActions(['steamConfirm']),
    onSubmit(e) {
        e.preventDefault();
       function setCookie(cname, cvalue, exdays) {
          var d = new Date();
          d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
          var expires = "expires="+d.toUTCString();
          document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }
       var self = this;
       $.ajax({
        type: 'POST',
        url: 'https://mail.halfhumangames.com/subscribe',
        api_key: "Z0skjz8tyn5VcME6DCmr",              
        list: "y3Ep0BGWhxkmrB1763I53pMQ",
        data: $('#sendy-form').serialize(),
        headers: {
            'Content-type': 'application/x-www-form-urlencoded'
            }, 
        boolean: true,
        success: function (data) {
           if(data.includes("You're already subscribed!"))
		    {
                 self.steamConfirm();
            }
            else if (data.includes("You're subscribed!"))
		    {
                self.steamConfirm();
            }
            else if (data.includes("Thank you, a confirmation email has been sent to you."))
		    {
                self.steamConfirm();
                setCookie("noPopup", "noPopup", 30);
            }
            else if (data.includes("A confirmation email had already been sent to you."))
		    {
                 self.onNotConfrimed(e);           
            }
            else {
                console.log(data); 
           }
        }
        
    });
      
    },
    onNotConfrimed(e){
          e.preventDefault();
       
       var self = this;
       $.ajax({
        type: 'POST',
        url: 'https://mail.halfhumangames.com/unsubscribe',
        api_key: "Z0skjz8tyn5VcME6DCmr",              
        list: "y3Ep0BGWhxkmrB1763I53pMQ",
        data: $('#sendy-form').serialize(),
        headers: {
            'Content-type': 'application/x-www-form-urlencoded'
            }, 
        boolean: true,
        success: function (data) {
               self.onReSubmit(e);
            
                 
        }
        
    });
    },
     onReSubmit(e){
       e.preventDefault();
       
       var self = this;
       $.ajax({
        type: 'POST',
        url: 'https://mail.halfhumangames.com/subscribe',
        api_key: "Z0skjz8tyn5VcME6DCmr",              
        list: "y3Ep0BGWhxkmrB1763I53pMQ",
        data: $('#sendy-form').serialize(),
        headers: {
            'Content-type': 'application/x-www-form-urlencoded'
            }, 
        boolean: true,
        success: function (data) {
                self.steamConfirm();
        }
        
    });
    }

 },
 mounted(){
     setInterval(function(){ 
  
   $('.sign__word').toggleClass('tada');  
   setTimeout(function(){
    
     $('.sign__word').toggleClass('tadi');  
   },2000)

},2000);
 }

};
</script>

<style scoped>
.sendyModal input#email {
    width: 100%;
    height: 40px;
    position: relative;
    top: 6px;
    font-size: 12px;
    padding: 10px;
    color: #a2a2a2;
}
.sendySubmit{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}
.sendySubmit input#submit {
    width: 127px;
}

p.g-recaptcha iframe {
    width: 100%;
    margin-top: 10px;
}
p.g-recaptcha div {
    width: 100% !important;
    height: auto !important;
}

p.g-recaptcha {
    margin-bottom: 0;
    width: 100%;
    margin-top: 10px;
}
.sendyWrap form {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}
.sendyModal label {
    width: 100%;
    font-family: Grandmaster;
    font-size: 13px;
    color: #595959;
    text-shadow: none;
    text-align: left;
    text-transform: none;
    font-weight: 100;
    margin-bottom: 0px;
    position: absolute;
}
#hp{
    display: none;
}
.sendySubmit {
    margin-top: 29px;
}
.sendySubmitInline input#email{
    max-width: 365px;
    margin-right: 10px;
    color: #555;
    width: 100%;
    font-weight: 400;
    font-size: 15px;
    padding: 10px;
    border-radius: 3px;
    color: #bfb6b6;
    height: 44px;
    background-color: #f5f5f5;
    border: 2px solid hsla(0,0%,100%,.39);
}
.sendySubmitInline {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 700px;
    margin: auto;
    margin-top: -17px;
}
p.subtitle span {
    font-size: 20px;
    text-shadow: -2.4px 2.6px 0 #282e35, 0.6px -2.4px 0 #282e35;
    display: inline-block;
}

.sendySubmitInline input#submit {
    width: 127px;
    height: 50px;
}
p.subtitle {
    font-size: 17px !important;
    margin-bottom: 0;
    color: #fff !important;
    font-family: Grandmaster;
    padding-top: 5px;
    padding-left: 23px;
    width: 100%;
    text-transform: uppercase;
    letter-spacing: .7px;
    line-height: 1.5;
    text-align: center;
    text-shadow: 2px 1px #ad6a09;
}

.sign__word {
  font-size: 5.6rem;
  text-align: center;
  line-height: 1;
  color: #3c9bd0;
  
  
}

@keyframes flash{
    0%{
        color: #b0e1fc;
        }
    25%{
        color: #66f0e9;
    }
    50%{
        color: #33ebe1;
        }
    75%{
        color: #7ee7a1;
        }
    100%{
        color: #74d4e6;
        }
}

@media only screen and (max-width: 500px) {
    .sendyInlineWrapper {
        position: relative;
        top: 20px;
    }
    .sendySubmitInline input#email {
        margin-bottom: 10px;
        margin-right: 0;
        max-width: 320px;
        
    }
    p.subtitle{
        padding-left: 0;
        padding-top: 0;
        line-height: 1.4;
        top: 0;
        font-size: 14px!important;
        position: relative;
    }
    .sendySubmitInline{
        margin-bottom: 2px;
        display: block;
    }
    form#sendy-form {
        margin-top: -38px;
    }
}
.animated.delay-3s {
  -webkit-animation-delay: 3s;
  animation-delay: 3s;
}
</style>


// WEBPACK FOOTER //
// src/views/Home/SendyInline.vue